export const createAlertSlice = (set, get) => ({
  alert: {
    open: false,
    text: "",
    textKey: "",
    textParams: undefined,
    success: true,
    autoClose: true,
    duration: 3000,
    afterClose: null,
  },

  showAlert: ({
    text = "",
    textKey = "",
    textParams,
    messageKey = "",
    messageParams,
    success = true,
    autoClose = success,
    duration = 3000,
    afterClose,
  } = {}) => {
    set((state) => ({
      alert: {
        ...state.alert,
        open: true,
        text,
        textKey: textKey || messageKey || "",
        textParams: textParams || messageParams,
        success,
        autoClose,
        duration,
        afterClose: afterClose ?? null,
      },
    }));
  },

  closeAlert: () => {
    const cb = get().alert.afterClose;

    set((state) => ({
      alert: {
        ...state.alert,
        open: false,
        afterClose: null,
      },
    }));

    cb?.();
  },
});
